<template>
  <Bar
    :chart-data="chartData"
    :chart-options="chartOptions"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale,
  LineController,
  BarController,
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale,
  LineController,
  BarController
);

export default {
  name: 'GraficoCombinadoAlunos',
  components: { Bar },
  props: {
    dados: {
      type: Array,
      required: true,
    },
    chartId: {
      type: String,
      default: 'grafico-combinado',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    width: {
      type: Number,
      default: 600,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: '',
      type: String,
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const labels = this.dados.map(d => d.aluno);

    const presencas = this.dados.map(d => d.presencas);
    const faltas = this.dados.map(d => d.faltas);
    const recuperadas = this.dados.map(d => d.recuperadas);
    const aulasPrevistas = this.dados.map(d => d.aulas_previstas);
    const aulasMinistradas = this.dados.map(d => d.total_aulas);

    return {
      chartData: {
        labels,
        datasets: [
          {
            type: 'bar',
            label: 'Presenças',
            backgroundColor: '#4caf50',
            data: presencas,
          },
          {
            type: 'bar',
            label: 'Faltas',
            backgroundColor: '#f44336',
            data: faltas,
          },
          {
            type: 'bar',
            label: 'Recuperadas',
            backgroundColor: '#2196f3',
            data: recuperadas,
            stack: 'aulas',
          },
          // Linhas
          {
            type: 'line',
            label: 'Aulas Previstas',
            borderColor: '#ff9800',
            backgroundColor: '#ff9800',
            data: aulasPrevistas,
            tension: 0.3,
            fill: false,
            yAxisID: 'y',
          },
          {
            type: 'line',
            label: 'Aulas Ministradas',
            borderColor: '#9c27b0',
            backgroundColor: '#9c27b0',
            data: aulasMinistradas,
            tension: 0.3,
            fill: false,
            yAxisID: 'y',
          },
        ],
      },
      chartOptions: {
        responsive: true,
        interaction: {
          mode: 'index',
          intersect: false,
        },
        stacked: false,
        scales: {
          y: {
            type: 'linear',
            position: 'left',
            title: {
              display: true,
              text: 'Quantidade de Aulas',
            },
          },
        },
        plugins: {
          tooltip: {
            mode: 'index',
            intersect: false,
          },
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: 'Resumo por Aluno (Combinado)',
          },
        },
      },
    };
  },
};
</script>
